module.exports = __webpack_public_path__ + "img/closeBtn.95e6aa3c.svg";